import React from 'react';

import { StockImagePanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const StockImagePanelPage = props => (
  <StockImagePanel {...props} notificationApi={notificationApi} />
);
